import { QuestionPlanIsSecret as Question } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-secret";

import { useDayTripPlanIsSecret } from "./hooks";

export const QuestionDayTripPlanIsSecret = () => {
	const { isSecret, onSetIsSecret, hotelID } = useDayTripPlanIsSecret();

	return <Question hotelID={hotelID} isSecret={isSecret} onSetIsSecret={onSetIsSecret} />;
};

QuestionDayTripPlanIsSecret.displayName = "QuestionDayTripPlanIsSecret";
